import { IconButton } from '../../IconButton';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronsLeftIcon,
  ChevronsRightIcon,
} from '../../Icons';
import styles from './styles.module.scss';

type Props = {
  /** 現在のページ番号（1始まり） */
  currentPage: number;
  /** 総ページ数 */
  totalPage: number;
  /** ページあたりの表示件数 */
  itemCount: number;
  /** 総件数 */
  totalCount: number;
  /** ページ変更コールバック */
  onPageChange: (page: number) => void;
  /** 追加のクラス名 */
  className?: string;
};

/**
 * ページネーション操作バー。
 * 選択中件数・表示範囲・ページ番号・ナビゲーションボタンを含む。
 */
export const TablePager: React.FC<Props> = ({
  currentPage,
  totalPage,
  itemCount,
  totalCount,
  onPageChange,
  className,
}) => {
  const startItem = totalCount === 0 ? 0 : (currentPage - 1) * itemCount + 1;
  const endItem = Math.min(currentPage * itemCount, totalCount);
  const isFirstPage = currentPage <= 1;
  const isLastPage = currentPage >= totalPage;

  return (
    <div className={[styles.container, className].filter(Boolean).join(' ')}>
      <div className={styles.rightSection}>
        <div className={styles.rangeSection}>
          <span className={styles.text}>
            {startItem}-{endItem}件 / 全{totalCount}件
          </span>
        </div>
        <div className={styles.pageSection}>
          <span className={styles.text}>
            {currentPage}/{totalPage}
          </span>
          <div className={styles.navButtons}>
            <IconButton
              icon={<ChevronsLeftIcon size='xs' />}
              variant='outline'
              size='lg'
              aria-label='最初のページへ'
              disabled={isFirstPage}
              onClick={() => onPageChange(1)}
            />
            <IconButton
              icon={<ChevronLeftIcon size='xs' />}
              variant='outline'
              size='lg'
              aria-label='前のページへ'
              disabled={isFirstPage}
              onClick={() => onPageChange(currentPage - 1)}
            />
            <IconButton
              icon={<ChevronRightIcon size='xs' />}
              variant='outline'
              size='lg'
              aria-label='次のページへ'
              disabled={isLastPage}
              onClick={() => onPageChange(currentPage + 1)}
            />
            <IconButton
              icon={<ChevronsRightIcon size='xs' />}
              variant='outline'
              size='lg'
              aria-label='最後のページへ'
              disabled={isLastPage}
              onClick={() => onPageChange(totalPage)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
